import { useErrorBoundary } from "react-error-boundary";
import styles from './error-fallback.module.css'
import { ButtonBar } from "../../controls/buttons";

export const ErrorFallback = ({ error }: any) => {

  const { resetBoundary } = useErrorBoundary();
  
    return (
      <div role="alert">
        <h3 className={styles.errorTitle}>Sorry, we have a bug</h3>
      
        <div className={styles.tableContainer}>
          <pre className={styles.redError}>{error.message} </pre>
          <ButtonBar><button className={styles.button} onClick={resetBoundary}>Try again</button></ButtonBar>
        </div>
      </div>
    );
  }